import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'config/axios';
import { useAuthContext } from 'context/AuthContext';
import DropdownSelect from 'components/DropdownSelect';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import Popup from 'components/Popup';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

type infoProps = {
    name: string;
    organization: string;
    instructors: {
        firebaseId: string;
        firstName: string;
        lastName: string;
        assigned: boolean;
    }[];
    setClassInfo: ({}) => void;
};

function info({
    name,
    organization,
    instructors,
    setClassInfo
}: infoProps) {
    const [remove, setRemove] = useState(false);
    const [error, setError] = useState('');

    const { user } = useAuthContext();
    const navigate = useNavigate();
    const { classId } = useParams();
    const removeClassRef = useOutsideClickHandler(() => setRemove(false));
    const errorRef = useOutsideClickHandler(() => setError(''));

    const assignInstructor = (instructor) => {
        axios.post('tutors/classes/tutor/assign/', {
                classId: classId,
                tutorId: instructor.firebaseId
            })
            .then(res => {
                setClassInfo({
                    name,
                    organization,
                    instructors: res.data.instructors
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    const removeClass = () => {
        axios.post(`tutors/classes/${classId}/remove/`)
            .then(res => {
                setRemove(false);
                navigate('/classes', { replace: true });
            })
            .catch(error => {
                setRemove(false);
                setError('Failed to remove class.');
                console.log(error);
            });
    }

    const removePopup = (
        <Popup
            title='Remove instructor'
            primaryButtonText='Remove'
            primaryButtonOnClick={removeClass}
            secondaryButtonText='Cancel'
            secondaryButtonOnClick={() => setRemove(false)}
            innerRef={removeClassRef}
        >
            <p>
                This class will be removed from your list of classes.
                <br/><br/>
                Are you sure you want to remove this class?
            </p>
        </Popup>
    );

    const failedPopup = (
        <Popup
            title='Failed'
            primaryButtonText='Close'
            primaryButtonOnClick={() => setError('')}
            innerRef={errorRef}
        >
            {error}
        </Popup>
    );

    return (
        <div className='class__info'>
            {remove && removePopup}
            {error && failedPopup}
            <div className='class__info__grid'>
                <TextInput
                    label='Class name'
                    value={name}
                    disabled
                />
                <TextInput
                    label='Organization'
                    value={organization}
                    disabled
                />
                <TextInput
                    label='Student number'
                    value={organization}
                    disabled
                />
                <DropdownSelect
                    label='Instructors'
                    // data={instructors.map(instructor => (`${instructor.firstName} ${instructor.lastName}`))}
                    data={instructors.map(instructor => ({
                        ...instructor,
                        name: `${instructor.firstName} ${instructor.lastName}`
                    }))}
                    dataKey='name'
                    selected={instructors.map(instructor => (instructor.assigned))}
                    onSelect={assignInstructor}
                />
            </div>

            {user.role === 'Admin' && 
                <Button
                    className='class__delete'
                    onClick={() => setRemove(true)}
                >
                    Remove Class
                </Button>
            }
        </div>
    );
}

export default info;